"use client";

import { Moon, Sun } from "lucide-react";
import { useTheme } from "./theme-provider";
import { Tooltip } from "./ui/tooltip";

export function ThemeToggle() {
  const { resolved, setTheme } = useTheme();

  const toggle = () => {
    setTheme(resolved === "dark" ? "light" : "dark");
  };

  const label = `Switch to ${resolved === "dark" ? "light" : "dark"} mode`;

  return (
    <Tooltip label={label} side="bottom">
      <button
        onClick={toggle}
        className="flex items-center justify-center size-10 sm:size-8 rounded-[var(--radius-md)] text-[var(--color-text-muted)] hover:text-[var(--color-text-primary)] hover:bg-[var(--color-bg-muted)] transition-colors focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-[var(--color-primary-muted)]"
        aria-label={label}
      >
        {resolved === "dark" ? (
          <Sun className="size-4" aria-hidden="true" />
        ) : (
          <Moon className="size-4" aria-hidden="true" />
        )}
      </button>
    </Tooltip>
  );
}
